import { useEffect, useState } from 'react';
import { CalendarClock } from 'lucide-react';
import { formatCountdown } from '../lib/time';
import type { GroupMeetup } from '../types';

interface MeetupBannerProps {
  meetup: GroupMeetup;
}

export function MeetupBanner({ meetup }: MeetupBannerProps) {
  const [now, setNow] = useState(Date.now);
  const timeLabel = new Intl.DateTimeFormat('it-IT', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(meetup.scheduled_for));

  useEffect(() => {
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(timer);
  }, [meetup.scheduled_for]);

  return (
    <section className="meetup-banner" aria-labelledby="meetup-banner-title">
      <span className="meetup-banner__icon"><CalendarClock size={23} aria-hidden="true" /></span>
      <div>
        <p className="eyebrow">Ritrovo di gruppo</p>
        <h2 id="meetup-banner-title">{meetup.location_emoji} {meetup.location_name}</h2>
        <p>Tutti lì <strong>{timeLabel}</strong></p>
      </div>
      <div className="meetup-countdown" aria-label={`Tempo rimanente: ${formatCountdown(meetup.scheduled_for, now)}`}>
        <span>Countdown</span>
        <strong>{formatCountdown(meetup.scheduled_for, now)}</strong>
      </div>
    </section>
  );
}
